import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Package, FileText, Shield, Settings as SettingsIcon, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import BrandLogo from '../BrandLogo';

const links = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, testid: 'nav-dashboard' },
  { to: '/shipments', label: 'Shipments', icon: Package, testid: 'nav-shipments' },
  { to: '/reports', label: 'Reports', icon: FileText, testid: 'nav-reports' },
  { to: '/admin', label: 'Admin', icon: Shield, testid: 'nav-admin' },
  { to: '/settings', label: 'Settings', icon: SettingsIcon, testid: 'nav-settings' },
];

export default function Sidebar() {
  const { user, signOut } = useAuth();

  const onSignOut = async () => {
    await signOut();
  };

  return (
    <aside className="hidden md:flex flex-col w-60 shrink-0 h-screen sticky top-0 bg-navy-900/50 border-r border-white/5 px-4 py-6">
      <div className="px-2 mb-8">
        <BrandLogo variant="sidebar" />
      </div>

      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono px-3 mb-3">Workspace</div>
      <nav className="flex flex-col gap-1">
        {links.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ${
                isActive
                  ? 'bg-cyan-glow/10 text-cyan-glow border border-cyan-glow/20'
                  : 'text-slate-400 hover:text-white hover:bg-white/5 border border-transparent'
              }`
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto border-t border-white/5 pt-4">
        <div className="px-3 py-2 mb-2">
          <div className="text-xs text-slate-400 truncate" data-testid="sidebar-user-email">{user?.email || 'Guest'}</div>
          <div className="text-[10px] text-slate-500 font-mono mt-0.5">Authenticated</div>
        </div>
        <button
          onClick={onSignOut}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-slate-400 hover:text-white hover:bg-white/5 transition-colors"
          data-testid="sidebar-signout-btn"
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </button>
      </div>
    </aside>
  );
}
